module.exports = __webpack_public_path__ + "static/media/home-color.9e0ffdad.svg";